// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Best Bets Modal Styling */
.best-bets-modal .modal-dialog {
    max-height: 95vh;
    margin: 2.5vh auto;
    max-width: 95vw;
    width: 95vw;
  }
  
  .best-bets-modal-body {
    max-height: 80vh;
    overflow: hidden;
    padding: 0;
  }
  
  /* Dual table container for separated headers */
  .best-bets-dual-table-container {
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  /* Fixed header container */
  .best-bets-header-container {
    flex-shrink: 0;
    overflow: hidden;
  }

  /* Scrollable body container */
  .best-bets-body-container {
    flex: 1 1;
    overflow-y: auto;
    overflow-x: hidden;
    /* Reserve space for scrollbar even when not present */
    scrollbar-gutter: stable;
  }

  /* Filter Row Styling */
  .best-bets-filter-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px 16px;
    padding: 8px 12px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    flex-shrink: 0;
  }

  .best-bets-filter-group {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .best-bets-filter-group label {
    font-size: 0.85rem;
    font-weight: 500;
    color: #495057;
    margin: 0;
  }

  .best-bets-filter-select {
    padding: 4px 8px;
    font-size: 0.85rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background-color: white;
    color: #495057;
    min-width: 100px;
    cursor: pointer;
  }

  .best-bets-filter-select:focus {
    outline: none;
    border-color: #80bdff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }

  .best-bets-filter-count {
    font-size: 0.8rem;
    color: #6c757d;
  }

  /* Dark mode filter styles */
  .dark-mode .best-bets-filter-row {
    background-color: #374151;
    border-bottom-color: #4b5563;
  }

  .dark-mode .best-bets-filter-group label {
    color: #e5e7eb;
  }

  .dark-mode .best-bets-filter-select {
    background-color: #1f2937;
    border-color: #4b5563;
    color: #e5e7eb;
  }

  .dark-mode .best-bets-filter-select:focus {
    border-color: #60a5fa;
    box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.25);
  }

  .dark-mode .best-bets-filter-count {
    color: #9ca3af;
  }

  /* Odds Filter Slider Styling */
  .best-bets-odds-row {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .best-bets-odds-filter {
    min-width: 140px;
  }

  .best-bets-slider {
    width: 80px;
    height: 4px;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    background: #dee2e6;
    border-radius: 2px;
    outline: none;
  }

  .best-bets-slider::-webkit-slider-thumb {
    appearance: none;
    -webkit-appearance: none;
    width: 14px;
    height: 14px;
    background: #0d6efd;
    border-radius: 50%;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .best-bets-slider::-moz-range-thumb {
    width: 14px;
    height: 14px;
    background: #0d6efd;
    border-radius: 50%;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .best-bets-slider:hover::-webkit-slider-thumb {
    background: #0b5ed7;
  }

  .best-bets-slider:hover::-moz-range-thumb {
    background: #0b5ed7;
  }

  .best-bets-odds-value {
    font-size: 0.8rem;
    font-weight: 500;
    color: #495057;
    min-width: 45px;
    text-align: right;
  }

  .best-bets-odds-input {
    width: 65px;
    padding: 4px 8px;
    font-size: 0.8rem;
    font-weight: 500;
    border: 1px solid #ced4da;
    border-radius: 4px;
    text-align: center;
    background: white;
    color: #495057;
  }

  .best-bets-odds-input:focus {
    outline: none;
    border-color: #0d6efd;
    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.15);
  }

  /* Hide spinner arrows on number input */
  .best-bets-odds-input::-webkit-inner-spin-button,
  .best-bets-odds-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .best-bets-odds-input[type="number"] {
    -moz-appearance: textfield;
  }

  /* Dark mode slider styles */
  .dark-mode .best-bets-slider {
    background: #4b5563;
  }

  .dark-mode .best-bets-slider::-webkit-slider-thumb {
    background: #60a5fa;
    border-color: #1f2937;
  }

  .dark-mode .best-bets-slider::-moz-range-thumb {
    background: #60a5fa;
    border-color: #1f2937;
  }

  .dark-mode .best-bets-slider:hover::-webkit-slider-thumb {
    background: #3b82f6;
  }

  .dark-mode .best-bets-slider:hover::-moz-range-thumb {
    background: #3b82f6;
  }

  .dark-mode .best-bets-odds-value {
    color: #e5e7eb;
  }

  .dark-mode .best-bets-odds-input {
    background: #374151;
    border-color: #4b5563;
    color: #e5e7eb;
  }

  .dark-mode .best-bets-odds-input:focus {
    border-color: #60a5fa;
    box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.2);
  }

  /* Header table styling */
  .best-bets-header-table {
    table-layout: fixed;
    margin-bottom: 0;
    border-bottom: none;
    width: 100%;
  }
  
  .best-bets-header-table thead th {
    background-color: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
    position: relative;
    padding: 0.5rem 0.25rem;
  }
  
  /* Body table styling */
  .best-bets-body-table {
    table-layout: fixed;
    margin-bottom: 0;
    width: 100%;
  }
  
  /* Ensure identical column widths between header and body */
  .best-bets-header-table th,
  .best-bets-body-table td {
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
  }
  
  .best-bets-body-table td {
    padding: 2px 4px !important;
    vertical-align: middle;
    line-height: 1.2;
  }
  
  .best-bets-body-table thead {
    display: none; /* Hide thead in body table since we have separate header */
  }
  
  /* Dark mode headers */
  .dark-mode .best-bets-header-table thead th {
    background-color: #374151;
    color: #e5e7eb;
    border-bottom-color: #4b5563;
  }
  
  /* Legacy support for old single table structure */
  .best-bets-table-container {
    max-height: 80vh;
    overflow-y: auto;
    overflow-x: auto;
  }
  
  .best-bets-table {
    table-layout: fixed;
    margin-bottom: 0;
  }
  
  .best-bets-table thead th {
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
    z-index: 10;
    border-bottom: 2px solid #dee2e6;
  }
  
  /* Dark mode sticky headers for legacy */
  .dark-mode .best-bets-table thead th {
    background-color: #374151;
    color: #e5e7eb;
    border-bottom-color: #4b5563;
  }
  
  .best-bets-game-cell {
    font-size: 0.8rem;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    width: 80px;
    text-align: center;
  }
  
  .best-bets-player-cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.85rem;
    width: 120px;
  }
  
  .best-bets-market-cell {
    font-size: 0.85rem;
    width: 60px;
    text-align: center;
  }
  
  .best-bets-odds-cell {
    font-size: 0.85rem;
    text-align: center;
    width: 60px;
  }
  
  .best-bets-odds-cell .edge-pill-one,
  .best-bets-odds-cell .edge-pill-two,
  .best-bets-odds-cell .edge-pill-three,
  .best-bets-odds-cell .edge-pill-three-dark {
    font-weight: bold;
    border-radius: 4px;
    display: block;
    margin: 0;
    padding: 0 1px;
    line-height: 2;
    text-align: center;
  }

  .best-bets-odds-cell .edge-pill-one {
    background-color: green;
    color: yellow;
  }

  .best-bets-odds-cell .edge-pill-two {
    background-color: #F59E0B;
    color: #1E40AF;
  }

  .best-bets-odds-cell .edge-pill-three {
    background-color: #E5E7EB;
    color: #374151;
  }

  .best-bets-odds-cell .edge-pill-three-dark {
    background-color: #3B82F6;
    color: white;
  }
  
  .best-bets-odds-cell.unavailable {
    background-color: #f8f9fa;
    color: #6c757d;
  }

  .best-bets-compact .best-bets-odds-cell {
    width: 42px;
    font-size: 0.75rem;
    padding: 2px 1px;
  }

  .best-bets-compact .best-bets-odds-cell img {
    height: 12px;
  }

  .best-bets-compact .best-bets-advantage-cell {
    width: 45px;
  }

  .best-bets-advantage-cell {
    width: 60px;
  }

  .best-bets-half .best-bets-game-cell {
    padding-left: 2px !important;
    padding-right: 2px !important;
  }

  .best-bets-half .best-bets-advantage-cell {
    width: 45px;
    overflow: hidden;
  }

  .best-bets-half .best-bets-team-logo {
    margin-right: 2px;
  }

  /* Best Bets Badge Styling */
  .best-bets-badge {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
  }
  
  .best-bets-badge.tier-edge-one {
    background-color: green !important;
    color: yellow !important;
    border: none !important;
    position: relative;
  }

  .best-bets-badge.tier-edge-one::before {
    content: "★ ";
    font-weight: bold;
  }

  .best-bets-badge.tier-edge-two {
    background-color: #F59E0B !important;
    color: #1E40AF !important;
    border: none !important;
    position: relative;
  }

  .best-bets-badge.tier-edge-two::before {
    content: "◆ ";
    font-weight: bold;
  }

  .best-bets-badge.tier-edge-three {
    background-color: #3B82F6 !important;
    color: white !important;
    border: none !important;
    position: relative;
  }
  
  .best-bets-badge.tier-edge-three::before {
    content: "● ";
    font-weight: bold;
  }
  
  .best-bets-team-logo {
    width: 20px;
    height: 20px;
    margin-right: 6px;
    align-self: flex-start;
  }
  
  .best-bet-list-item .best-bets-team-logo-small {
    width: 16px !important;
    height: 16px !important;
    flex-shrink: 0;
  }
  
  /* Alternating row shading for desktop table */
  .best-bets-even-row {
    background-color: #ffffff;
  }
  
  .best-bets-odd-row {
    background-color: #f8f9fa;
  }
  
  .best-bets-even-row:hover {
    background-color: #f1f3f5;
  }
  
  .best-bets-odd-row:hover {
    background-color: #e9ecef;
  }
  
  /* Dark mode table styles */
  .dark-mode .best-bets-modal .modal-content {
    background-color: #1f2937;
    color: #e5e7eb;
  }
  
  .dark-mode .best-bets-table {
    background-color: #374151;
    color: #e5e7eb;
  }
  
  .dark-mode .best-bets-table thead {
    background-color: #1f2937;
  }
  
  /* Dark mode for dual table structure */
  .dark-mode .best-bets-header-table {
    background-color: #374151;
    color: #e5e7eb;
  }
  
  .dark-mode .best-bets-body-table {
    background-color: #374151;
    color: #e5e7eb;
  }
  
  /* Dark mode borders */
  .dark-mode .best-bets-header-table th,
  .dark-mode .best-bets-body-table td {
    border-left-color: #4b5563;
    border-right-color: #4b5563;
  }
  
  .dark-mode .best-bets-even-row {
    background-color: #374151;
  }
  
  .dark-mode .best-bets-odd-row {
    background-color: #4b5563;
  }
  
  .dark-mode .best-bets-even-row:hover {
    background-color: #4b5563;
  }
  
  .dark-mode .best-bets-odd-row:hover {
    background-color: #6b7280;
  }
  
  .dark-mode .best-bets-odds-cell.unavailable {
    background-color: #4b5563;
    color: #9ca3af;
  }
  
  /* Best Bets Mobile Takeover */
  .best-bets-takeover {
    position: fixed;
    top: 56px; /* Height of navbar */
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: calc(100vh - 56px);
    background: white;
    z-index: 1040; /* Higher than navbar dropdown (1030) but below modals (1050) */
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  .best-bets-takeover-header {
    background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
    color: white;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  
  .best-bets-takeover-body {
    flex: 1 1;
    overflow-y: auto;
    background: #f3f4f6;
    padding: 1rem 0.5rem;
  }
  
  /* Dark mode takeover styles */
  .dark-mode .best-bets-takeover {
    background: #1f2937;
  }
  
  .dark-mode .best-bets-takeover-header {
    background: linear-gradient(135deg, #111827 0%, #000000 100%);
    border-bottom: 1px solid #374151;
  }
  
  .dark-mode .best-bets-takeover-body {
    background: #111827;
  }

  /* Mobile Filter Panel */
  .best-bets-filter-panel {
    max-height: 0;
    overflow: hidden;
    background: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    transition: max-height 0.3s ease-out;
  }

  .best-bets-filter-panel.open {
    max-height: 300px;
    transition: max-height 0.3s ease-in;
  }

  .filter-panel-content {
    padding: 12px;
  }

  .mobile-filter-row {
    display: flex;
    gap: 8px;
    margin-bottom: 10px;
    flex-wrap: wrap;
  }

  .mobile-filter-row:last-child {
    margin-bottom: 0;
  }

  .mobile-filter-group {
    flex: 1 1;
    min-width: 80px;
  }

  .mobile-filter-group label {
    display: block;
    font-size: 0.7rem;
    font-weight: 600;
    color: #6b7280;
    margin-bottom: 4px;
    text-transform: uppercase;
  }

  .mobile-filter-group select {
    width: 100%;
    padding: 6px 8px;
    font-size: 0.8rem;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    background: white;
    color: #374151;
  }

  .mobile-filter-group.slider-group {
    flex: 1 1;
    min-width: 120px;
  }

  .slider-with-value {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .slider-with-value input[type="range"] {
    flex: 1 1;
    height: 4px;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    background: #d1d5db;
    border-radius: 2px;
    outline: none;
  }

  .slider-with-value input[type="range"]::-webkit-slider-thumb {
    appearance: none;
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    background: #0d6efd;
    border-radius: 50%;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .slider-with-value input[type="range"]::-moz-range-thumb {
    width: 16px;
    height: 16px;
    background: #0d6efd;
    border-radius: 50%;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .slider-with-value span {
    font-size: 0.75rem;
    font-weight: 500;
    color: #374151;
    min-width: 40px;
    text-align: right;
  }

  .slider-with-value .odds-input {
    width: 60px;
    padding: 4px 6px;
    font-size: 0.75rem;
    font-weight: 500;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    text-align: center;
    background: white;
    color: #374151;
  }

  .slider-with-value .odds-input:focus {
    outline: none;
    border-color: #0d6efd;
    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.15);
  }

  /* Hide spinner arrows on number input */
  .slider-with-value .odds-input::-webkit-inner-spin-button,
  .slider-with-value .odds-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .slider-with-value .odds-input[type="number"] {
    -moz-appearance: textfield;
  }

  .filter-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 8px;
    border-top: 1px solid #e5e7eb;
  }

  .filter-status {
    font-size: 0.75rem;
    color: #6b7280;
  }

  /* Dark mode filter panel */
  .dark-mode .best-bets-filter-panel {
    background: #1f2937;
    border-bottom-color: #374151;
  }

  .dark-mode .mobile-filter-group label {
    color: #9ca3af;
  }

  .dark-mode .mobile-filter-group select {
    background: #374151;
    border-color: #4b5563;
    color: #e5e7eb;
  }

  .dark-mode .slider-with-value input[type="range"] {
    background: #4b5563;
  }

  .dark-mode .slider-with-value input[type="range"]::-webkit-slider-thumb {
    background: #60a5fa;
    border-color: #1f2937;
  }

  .dark-mode .slider-with-value input[type="range"]::-moz-range-thumb {
    background: #60a5fa;
    border-color: #1f2937;
  }

  .dark-mode .slider-with-value span {
    color: #e5e7eb;
  }

  .dark-mode .slider-with-value .odds-input {
    background: #374151;
    border-color: #4b5563;
    color: #e5e7eb;
  }

  .dark-mode .slider-with-value .odds-input:focus {
    border-color: #60a5fa;
    box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.2);
  }

  .dark-mode .filter-actions {
    border-top-color: #374151;
  }

  .dark-mode .filter-status {
    color: #9ca3af;
  }

  /* Toggle buttons styling */
  .best-bets-takeover-header .btn-group {
    border-radius: 4px;
    overflow: hidden;
  }
  
  .best-bets-takeover-header .btn {
    padding: 0.25rem 0.75rem;
    font-size: 0.875rem;
    border: none;
  }
  
  /* Best Bets Cards View */
  .best-bets-mobile-cards {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .best-bet-card {
    background: white;
    border-radius: 8px;
    padding: 1rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-left: 4px solid transparent;
  }
  
  /* Alternating background for cards */
  .best-bets-mobile-cards .best-bet-card:nth-child(even) {
    background: #fafafa;
  }
  
  .dark-mode .best-bet-card {
    background: #1f2937;
    color: #e5e7eb;
  }
  
  .dark-mode .best-bets-mobile-cards .best-bet-card:nth-child(even) {
    background: #374151;
  }
  
  .best-bet-card.tier-edge-one {
    border-left-color: green;
  }

  .best-bet-card.tier-edge-two {
    border-left-color: #F59E0B;
  }

  .best-bet-card.tier-edge-three {
    border-left-color: #3B82F6;
  }
  
  .best-bet-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
  }
  
  .best-bet-game {
    font-size: 0.85rem;
    color: #6c757d;
    font-weight: 500;
  }
  
  .best-bet-player {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1rem;
    font-weight: 600;
    font-size: 1rem;
  }
  
  .best-bet-player .best-bets-team-logo {
    width: 20px;
    height: 20px;
  }
  
  .best-bet-odds-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
  }
  
  .odds-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem;
    background: #f8f9fa;
    border-radius: 4px;
    transition: all 0.2s ease;
  }
  
  .dark-mode .odds-item {
    background: #374151;
    color: #e5e7eb;
  }
  
  
  .odds-item.best-book {
    background: green;
    color: yellow;
    font-weight: bold;
  }
  
  .best-bet-card.tier-edge-two .odds-item.best-book {
    background: #F59E0B;
    color: #1E40AF;
    font-weight: bold;
  }
  
  
  .odds-item img {
    height: 20px;
    width: auto;
  }
  
  .odds-item span {
    font-family: 'Inter', sans-serif;
    font-feature-settings: 'tnum';
    font-size: 0.9rem;
  }
  
  /* Best Bets List View */
  .best-bets-mobile-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .best-bet-list-item {
    background: white;
    border-radius: 6px;
    padding: 0.75rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border-left: 3px solid transparent;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.75rem;
    transition: all 0.2s ease;
  }
  
  /* Alternating colors based on index within parent */
  .best-bets-mobile-list > div:nth-child(even) .best-bet-list-item {
    background: #fafafa;
  }
  
  .dark-mode .best-bet-list-item {
    background: #1f2937;
    color: #e5e7eb;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }
  
  .dark-mode .best-bets-mobile-list > div:nth-child(even) .best-bet-list-item {
    background: #374151;
  }
  
  /* Remove default alternating - we'll handle it differently */
  
  .best-bet-list-item:hover {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }
  
  .best-bet-list-item.expanded {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    margin-bottom: 0;
  }
  
  .best-bet-list-item.tier-edge-one {
    border-left-color: green;
  }

  .best-bet-list-item.tier-edge-two {
    border-left-color: #F59E0B;
  }

  .best-bet-list-item.tier-edge-three {
    border-left-color: #3B82F6;
  }
  
  /* Left side of list item */
  .best-bet-list-left {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
  
  .best-bet-list-game {
    font-size: 0.75rem;
    color: #6c757d;
    text-align: left;
  }
  
  .best-bet-list-player {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-weight: 600;
    font-size: 0.9rem;
    flex: 1 1;
    min-width: 0;
  }
  
  .best-bet-list-player span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  /* Right side of list item - FIXED GRID LAYOUT */
  .best-bet-list-right {
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    grid-template-rows: auto auto;
    gap: 0.25rem 0.5rem;
    flex-shrink: 0;
    align-items: center;
    min-width: 160px;
  }
  
  /* Row 1 positioning */
  .best-bet-list-odds {
    grid-column: 1 / span 2;
    grid-row: 1;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    height: 20px;
  }
  
  .expand-indicator {
    grid-column: 3;
    grid-row: 1;
    font-size: 0.7rem;
    color: #adb5bd;
    transition: transform 0.2s ease;
    justify-self: center;
  }
  
  /* Row 2 positioning */
  .market-badge-small {
    grid-column: 1;
    grid-row: 2;
    background: #e9ecef;
    padding: 0.05rem 0.25rem;
    border-radius: 2px;
    font-size: 0.65rem;
    font-weight: 500;
    color: #495057;
    justify-self: start;
  }
  
  .dark-mode .market-badge-small {
    background: #4b5563;
    color: #e5e7eb;
  }
  
  .best-bet-list-right .best-bets-badge {
    grid-column: 2;
    grid-row: 2;
    justify-self: center;
  }
  
  /* Odds display components */
  .best-odds-group {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }
  
  .best-odds {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    height: 20px;
  }
  
  .best-odds img {
    height: 14px !important;
    width: auto !important;
    flex-shrink: 0;
  }
  
  .next-best-section {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    height: 20px;
    justify-content: flex-start;
  }
  
  .next-best-section img {
    height: 14px !important;
    width: auto !important;
    max-width: 14px !important;
    flex-shrink: 0;
  }
  
  .odds-value {
    font-family: 'Inter', sans-serif;
    font-feature-settings: 'tnum';
    font-weight: 600;
    font-size: 0.85rem;
    line-height: 1.2;
  }
  
  .vs-text {
    font-size: 0.75rem;
    color: #adb5bd;
    font-style: italic;
    line-height: 1.2;
    align-self: center;
  }
  
  .best-odds .odds-value {
    color: #000;
    font-weight: bold;
  }
  
  .best-bet-card.tier-edge-two .best-odds .odds-value {
    color: #1E40AF;
    font-weight: bold;
  }
  
  .best-bet-card.tier-edge-three .best-odds .odds-value {
    color: white;
    font-weight: bold;
  }
  
  /* Dark mode colors for mobile list view */
  .dark-mode .best-odds .odds-value {
    color: #ffffff;
    font-weight: bold;
  }
  
  .dark-mode .next-best-section .odds-value {
    color: #9ca3af;
    font-weight: 500;
  }
  
  .next-best-section .odds-value {
    color: #6c757d;
    font-weight: 500;
  }
  
  /* Expanded view */
  .best-bet-expanded {
    background: #f8f9fa;
    border-left: 3px solid transparent;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    padding: 0.75rem;
    margin-bottom: 0.5rem;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
  }
  
  .dark-mode .best-bet-expanded {
    background: #111827;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
  }
  
  .best-bet-list-item.tier-edge-one + .best-bet-expanded {
    border-left-color: green;
  }

  .best-bet-list-item.tier-edge-two + .best-bet-expanded {
    border-left-color: #F59E0B;
  }

  .best-bet-list-item.tier-edge-three + .best-bet-expanded {
    border-left-color: #3B82F6;
  }
  
  .all-odds-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
  }
  
  .expanded-odds-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem;
    background: white;
    border-radius: 4px;
    border: 1px solid #e9ecef;
  }
  
  .dark-mode .expanded-odds-item {
    background: #374151;
    border: 1px solid #4b5563;
    color: #e5e7eb;
  }
  
  .dark-mode .expanded-odds-item.best-book.edge-three {
    border: 2px solid #3b82f6;
    background: rgba(59, 130, 246, 0.2);
  }
  
  .expanded-odds-item.best-book {
    border: 2px solid green;
    background: rgba(0, 128, 0, 0.05);
  }
  
  .expanded-odds-item.best-book.edge-two {
    border: 2px solid #F59E0B;
    background: rgba(245, 158, 11, 0.05);
  }
  
  .expanded-odds-item img {
    height: 20px;
    width: auto;
  }
  
  .expanded-odds-item span {
    font-family: 'Inter', sans-serif;
    font-feature-settings: 'tnum';
    font-weight: 500;
    font-size: 0.9rem;
    color: #6c757d;
  }
  
  /* Dark mode: make non-best books lighter */
  .dark-mode .expanded-odds-item span {
    color: #9ca3af;
    font-weight: 500;
  }
  
  /* Best book spans should be white and bold in dark mode */
  .dark-mode .expanded-odds-item.best-book span {
    color: #ffffff;
    font-weight: 700;
  }
  
  .dark-mode .expanded-odds-item.best-book.edge-two span {
    color: #ffffff;
    font-weight: 700;
  }
  
  .dark-mode .expanded-odds-item.best-book.edge-three span {
    color: #ffffff;
    font-weight: 700;
  }
  
  /* Light mode best book colors */
  .expanded-odds-item.best-book span {
    color: green;
    font-weight: 700;
  }

  .expanded-odds-item.best-book.edge-two span {
    color: #1E40AF;
    font-weight: 700;
  }

  .expanded-odds-item.best-book.edge-three {
    border: 2px solid #3B82F6;
    background: rgba(59, 130, 246, 0.05);
  }

  .expanded-odds-item.best-book.edge-three span {
    color: #3B82F6;
    font-weight: 700;
  }`, "",{"version":3,"sources":["webpack://./src/styles/BestBets.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;EACZ;;EAEA,+CAA+C;EAC/C;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA,2BAA2B;EAC3B;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,8BAA8B;EAC9B;IACE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,sDAAsD;IACtD,wBAAwB;EAC1B;;EAEA,uBAAuB;EACvB;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,gCAAgC;IAChC,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA,4BAA4B;EAC5B;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,8CAA8C;EAChD;;EAEA;IACE,cAAc;EAChB;;EAEA,+BAA+B;EAC/B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,wCAAwC;EAC1C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,wCAAwC;EAC1C;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,8CAA8C;EAChD;;EAEA,wCAAwC;EACxC;;IAEE,wBAAwB;IACxB,SAAS;EACX;EACA;IACE,0BAA0B;EAC5B;;EAEA,4BAA4B;EAC5B;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA,yBAAyB;EACzB;IACE,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA,uBAAuB;EACvB;IACE,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;EACb;;EAEA,2DAA2D;EAC3D;;IAEE,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa,EAAE,2DAA2D;EAC5E;;EAEA,sBAAsB;EACtB;IACE,yBAAyB;IACzB,cAAc;IACd,4BAA4B;EAC9B;;EAEA,kDAAkD;EAClD;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,yBAAyB;IACzB,WAAW;IACX,gCAAgC;EAClC;;EAEA,wCAAwC;EACxC;IACE,yBAAyB;IACzB,cAAc;IACd,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;;EAEA;;;;IAIE,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,cAAc;IACd,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,4BAA4B;EAC5B;IACE,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;EAChB;;EAEA,8CAA8C;EAC9C;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,2BAA2B;EAC3B;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,uCAAuC;EACvC;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA,sBAAsB;EACtB;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA,8BAA8B;EAC9B;IACE,eAAe;IACf,SAAS,EAAE,qBAAqB;IAChC,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa,EAAE,+DAA+D;IAC9E,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,6DAA6D;IAC7D,YAAY;IACZ,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA,8BAA8B;EAC9B;IACE,mBAAmB;EACrB;;EAEA;IACE,6DAA6D;IAC7D,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA,wBAAwB;EACxB;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,oCAAoC;EACtC;;EAEA;IACE,iBAAiB;IACjB,mCAAmC;EACrC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,SAAO;IACP,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,wCAAwC;EAC1C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,8CAA8C;EAChD;;EAEA,wCAAwC;EACxC;;IAEE,wBAAwB;IACxB,SAAS;EACX;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA,2BAA2B;EAC3B;IACE,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA,2BAA2B;EAC3B;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,YAAY;EACd;;EAEA,yBAAyB;EACzB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;IACxC,kCAAkC;EACpC;;EAEA,qCAAqC;EACrC;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;;EAGA;IACE,iBAAiB;IACjB,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,iBAAiB;EACnB;;;EAGA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,gCAAgC;IAChC,6BAA6B;IAC7B,iBAAiB;EACnB;;EAEA,wBAAwB;EACxB;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,kCAAkC;IAClC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;EAC3B;;EAEA,oDAAoD;EACpD;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,wCAAwC;EAC1C;;EAEA;IACE,mBAAmB;EACrB;;EAEA,6DAA6D;;EAE7D;IACE,yCAAyC;EAC3C;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,2BAA2B;EAC3B;IACE,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,SAAO;IACP,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,gDAAgD;EAChD;IACE,aAAa;IACb,mCAAmC;IACnC,6BAA6B;IAC7B,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,+BAA+B;IAC/B,oBAAoB;EACtB;;EAEA,sBAAsB;EACtB;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,oBAAoB;EACtB;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,0BAA0B;IAC1B,cAAc;EAChB;;EAEA;IACE,gCAAgC;IAChC,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA,0CAA0C;EAC1C;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,mBAAmB;IACnB,kCAAkC;IAClC,8BAA8B;IAC9B,+BAA+B;IAC/B,gBAAgB;IAChB,qBAAqB;IACrB,yCAAyC;EAC3C;;EAEA;IACE,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,mCAAmC;EACrC;;EAEA;IACE,uBAAuB;IACvB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;IACzB,oCAAoC;EACtC;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,gCAAgC;IAChC,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;EAEA,2CAA2C;EAC3C;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,0DAA0D;EAC1D;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,oCAAoC;EACtC;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB","sourcesContent":["/* Best Bets Modal Styling */\n.best-bets-modal .modal-dialog {\n    max-height: 95vh;\n    margin: 2.5vh auto;\n    max-width: 95vw;\n    width: 95vw;\n  }\n  \n  .best-bets-modal-body {\n    max-height: 80vh;\n    overflow: hidden;\n    padding: 0;\n  }\n  \n  /* Dual table container for separated headers */\n  .best-bets-dual-table-container {\n    max-height: 80vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n  \n  /* Fixed header container */\n  .best-bets-header-container {\n    flex-shrink: 0;\n    overflow: hidden;\n  }\n\n  /* Scrollable body container */\n  .best-bets-body-container {\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    /* Reserve space for scrollbar even when not present */\n    scrollbar-gutter: stable;\n  }\n\n  /* Filter Row Styling */\n  .best-bets-filter-row {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px 16px;\n    padding: 8px 12px;\n    background-color: #f8f9fa;\n    border-bottom: 1px solid #dee2e6;\n    flex-shrink: 0;\n  }\n\n  .best-bets-filter-group {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .best-bets-filter-group label {\n    font-size: 0.85rem;\n    font-weight: 500;\n    color: #495057;\n    margin: 0;\n  }\n\n  .best-bets-filter-select {\n    padding: 4px 8px;\n    font-size: 0.85rem;\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n    background-color: white;\n    color: #495057;\n    min-width: 100px;\n    cursor: pointer;\n  }\n\n  .best-bets-filter-select:focus {\n    outline: none;\n    border-color: #80bdff;\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n  }\n\n  .best-bets-filter-count {\n    font-size: 0.8rem;\n    color: #6c757d;\n  }\n\n  /* Dark mode filter styles */\n  .dark-mode .best-bets-filter-row {\n    background-color: #374151;\n    border-bottom-color: #4b5563;\n  }\n\n  .dark-mode .best-bets-filter-group label {\n    color: #e5e7eb;\n  }\n\n  .dark-mode .best-bets-filter-select {\n    background-color: #1f2937;\n    border-color: #4b5563;\n    color: #e5e7eb;\n  }\n\n  .dark-mode .best-bets-filter-select:focus {\n    border-color: #60a5fa;\n    box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.25);\n  }\n\n  .dark-mode .best-bets-filter-count {\n    color: #9ca3af;\n  }\n\n  /* Odds Filter Slider Styling */\n  .best-bets-odds-row {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n\n  .best-bets-odds-filter {\n    min-width: 140px;\n  }\n\n  .best-bets-slider {\n    width: 80px;\n    height: 4px;\n    cursor: pointer;\n    appearance: none;\n    -webkit-appearance: none;\n    background: #dee2e6;\n    border-radius: 2px;\n    outline: none;\n  }\n\n  .best-bets-slider::-webkit-slider-thumb {\n    appearance: none;\n    -webkit-appearance: none;\n    width: 14px;\n    height: 14px;\n    background: #0d6efd;\n    border-radius: 50%;\n    cursor: pointer;\n    border: 2px solid white;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  }\n\n  .best-bets-slider::-moz-range-thumb {\n    width: 14px;\n    height: 14px;\n    background: #0d6efd;\n    border-radius: 50%;\n    cursor: pointer;\n    border: 2px solid white;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  }\n\n  .best-bets-slider:hover::-webkit-slider-thumb {\n    background: #0b5ed7;\n  }\n\n  .best-bets-slider:hover::-moz-range-thumb {\n    background: #0b5ed7;\n  }\n\n  .best-bets-odds-value {\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: #495057;\n    min-width: 45px;\n    text-align: right;\n  }\n\n  .best-bets-odds-input {\n    width: 65px;\n    padding: 4px 8px;\n    font-size: 0.8rem;\n    font-weight: 500;\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n    text-align: center;\n    background: white;\n    color: #495057;\n  }\n\n  .best-bets-odds-input:focus {\n    outline: none;\n    border-color: #0d6efd;\n    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.15);\n  }\n\n  /* Hide spinner arrows on number input */\n  .best-bets-odds-input::-webkit-inner-spin-button,\n  .best-bets-odds-input::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  .best-bets-odds-input[type=\"number\"] {\n    -moz-appearance: textfield;\n  }\n\n  /* Dark mode slider styles */\n  .dark-mode .best-bets-slider {\n    background: #4b5563;\n  }\n\n  .dark-mode .best-bets-slider::-webkit-slider-thumb {\n    background: #60a5fa;\n    border-color: #1f2937;\n  }\n\n  .dark-mode .best-bets-slider::-moz-range-thumb {\n    background: #60a5fa;\n    border-color: #1f2937;\n  }\n\n  .dark-mode .best-bets-slider:hover::-webkit-slider-thumb {\n    background: #3b82f6;\n  }\n\n  .dark-mode .best-bets-slider:hover::-moz-range-thumb {\n    background: #3b82f6;\n  }\n\n  .dark-mode .best-bets-odds-value {\n    color: #e5e7eb;\n  }\n\n  .dark-mode .best-bets-odds-input {\n    background: #374151;\n    border-color: #4b5563;\n    color: #e5e7eb;\n  }\n\n  .dark-mode .best-bets-odds-input:focus {\n    border-color: #60a5fa;\n    box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.2);\n  }\n\n  /* Header table styling */\n  .best-bets-header-table {\n    table-layout: fixed;\n    margin-bottom: 0;\n    border-bottom: none;\n    width: 100%;\n  }\n  \n  .best-bets-header-table thead th {\n    background-color: #f8f9fa;\n    border-bottom: 2px solid #dee2e6;\n    position: relative;\n    padding: 0.5rem 0.25rem;\n  }\n  \n  /* Body table styling */\n  .best-bets-body-table {\n    table-layout: fixed;\n    margin-bottom: 0;\n    width: 100%;\n  }\n  \n  /* Ensure identical column widths between header and body */\n  .best-bets-header-table th,\n  .best-bets-body-table td {\n    border-left: 1px solid #dee2e6;\n    border-right: 1px solid #dee2e6;\n  }\n  \n  .best-bets-body-table td {\n    padding: 2px 4px !important;\n    vertical-align: middle;\n    line-height: 1.2;\n  }\n  \n  .best-bets-body-table thead {\n    display: none; /* Hide thead in body table since we have separate header */\n  }\n  \n  /* Dark mode headers */\n  .dark-mode .best-bets-header-table thead th {\n    background-color: #374151;\n    color: #e5e7eb;\n    border-bottom-color: #4b5563;\n  }\n  \n  /* Legacy support for old single table structure */\n  .best-bets-table-container {\n    max-height: 80vh;\n    overflow-y: auto;\n    overflow-x: auto;\n  }\n  \n  .best-bets-table {\n    table-layout: fixed;\n    margin-bottom: 0;\n  }\n  \n  .best-bets-table thead th {\n    position: sticky;\n    top: 0;\n    background-color: #f8f9fa;\n    z-index: 10;\n    border-bottom: 2px solid #dee2e6;\n  }\n  \n  /* Dark mode sticky headers for legacy */\n  .dark-mode .best-bets-table thead th {\n    background-color: #374151;\n    color: #e5e7eb;\n    border-bottom-color: #4b5563;\n  }\n  \n  .best-bets-game-cell {\n    font-size: 0.8rem;\n    white-space: normal;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n    width: 80px;\n    text-align: center;\n  }\n  \n  .best-bets-player-cell {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 0.85rem;\n    width: 120px;\n  }\n  \n  .best-bets-market-cell {\n    font-size: 0.85rem;\n    width: 60px;\n    text-align: center;\n  }\n  \n  .best-bets-odds-cell {\n    font-size: 0.85rem;\n    text-align: center;\n    width: 60px;\n  }\n  \n  .best-bets-odds-cell .edge-pill-one,\n  .best-bets-odds-cell .edge-pill-two,\n  .best-bets-odds-cell .edge-pill-three,\n  .best-bets-odds-cell .edge-pill-three-dark {\n    font-weight: bold;\n    border-radius: 4px;\n    display: block;\n    margin: 0;\n    padding: 0 1px;\n    line-height: 2;\n    text-align: center;\n  }\n\n  .best-bets-odds-cell .edge-pill-one {\n    background-color: green;\n    color: yellow;\n  }\n\n  .best-bets-odds-cell .edge-pill-two {\n    background-color: #F59E0B;\n    color: #1E40AF;\n  }\n\n  .best-bets-odds-cell .edge-pill-three {\n    background-color: #E5E7EB;\n    color: #374151;\n  }\n\n  .best-bets-odds-cell .edge-pill-three-dark {\n    background-color: #3B82F6;\n    color: white;\n  }\n  \n  .best-bets-odds-cell.unavailable {\n    background-color: #f8f9fa;\n    color: #6c757d;\n  }\n\n  .best-bets-compact .best-bets-odds-cell {\n    width: 42px;\n    font-size: 0.75rem;\n    padding: 2px 1px;\n  }\n\n  .best-bets-compact .best-bets-odds-cell img {\n    height: 12px;\n  }\n\n  .best-bets-compact .best-bets-advantage-cell {\n    width: 45px;\n  }\n\n  .best-bets-advantage-cell {\n    width: 60px;\n  }\n\n  .best-bets-half .best-bets-game-cell {\n    padding-left: 2px !important;\n    padding-right: 2px !important;\n  }\n\n  .best-bets-half .best-bets-advantage-cell {\n    width: 45px;\n    overflow: hidden;\n  }\n\n  .best-bets-half .best-bets-team-logo {\n    margin-right: 2px;\n  }\n\n  /* Best Bets Badge Styling */\n  .best-bets-badge {\n    font-size: 0.75rem;\n    padding: 0.25rem 0.5rem;\n    border-radius: 4px;\n  }\n  \n  .best-bets-badge.tier-edge-one {\n    background-color: green !important;\n    color: yellow !important;\n    border: none !important;\n    position: relative;\n  }\n\n  .best-bets-badge.tier-edge-one::before {\n    content: \"★ \";\n    font-weight: bold;\n  }\n\n  .best-bets-badge.tier-edge-two {\n    background-color: #F59E0B !important;\n    color: #1E40AF !important;\n    border: none !important;\n    position: relative;\n  }\n\n  .best-bets-badge.tier-edge-two::before {\n    content: \"◆ \";\n    font-weight: bold;\n  }\n\n  .best-bets-badge.tier-edge-three {\n    background-color: #3B82F6 !important;\n    color: white !important;\n    border: none !important;\n    position: relative;\n  }\n  \n  .best-bets-badge.tier-edge-three::before {\n    content: \"● \";\n    font-weight: bold;\n  }\n  \n  .best-bets-team-logo {\n    width: 20px;\n    height: 20px;\n    margin-right: 6px;\n    align-self: flex-start;\n  }\n  \n  .best-bet-list-item .best-bets-team-logo-small {\n    width: 16px !important;\n    height: 16px !important;\n    flex-shrink: 0;\n  }\n  \n  /* Alternating row shading for desktop table */\n  .best-bets-even-row {\n    background-color: #ffffff;\n  }\n  \n  .best-bets-odd-row {\n    background-color: #f8f9fa;\n  }\n  \n  .best-bets-even-row:hover {\n    background-color: #f1f3f5;\n  }\n  \n  .best-bets-odd-row:hover {\n    background-color: #e9ecef;\n  }\n  \n  /* Dark mode table styles */\n  .dark-mode .best-bets-modal .modal-content {\n    background-color: #1f2937;\n    color: #e5e7eb;\n  }\n  \n  .dark-mode .best-bets-table {\n    background-color: #374151;\n    color: #e5e7eb;\n  }\n  \n  .dark-mode .best-bets-table thead {\n    background-color: #1f2937;\n  }\n  \n  /* Dark mode for dual table structure */\n  .dark-mode .best-bets-header-table {\n    background-color: #374151;\n    color: #e5e7eb;\n  }\n  \n  .dark-mode .best-bets-body-table {\n    background-color: #374151;\n    color: #e5e7eb;\n  }\n  \n  /* Dark mode borders */\n  .dark-mode .best-bets-header-table th,\n  .dark-mode .best-bets-body-table td {\n    border-left-color: #4b5563;\n    border-right-color: #4b5563;\n  }\n  \n  .dark-mode .best-bets-even-row {\n    background-color: #374151;\n  }\n  \n  .dark-mode .best-bets-odd-row {\n    background-color: #4b5563;\n  }\n  \n  .dark-mode .best-bets-even-row:hover {\n    background-color: #4b5563;\n  }\n  \n  .dark-mode .best-bets-odd-row:hover {\n    background-color: #6b7280;\n  }\n  \n  .dark-mode .best-bets-odds-cell.unavailable {\n    background-color: #4b5563;\n    color: #9ca3af;\n  }\n  \n  /* Best Bets Mobile Takeover */\n  .best-bets-takeover {\n    position: fixed;\n    top: 56px; /* Height of navbar */\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100vw;\n    height: calc(100vh - 56px);\n    background: white;\n    z-index: 1040; /* Higher than navbar dropdown (1030) but below modals (1050) */\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n  \n  .best-bets-takeover-header {\n    background: linear-gradient(135deg, #374151 0%, #1f2937 100%);\n    color: white;\n    padding: 1rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .best-bets-takeover-body {\n    flex: 1;\n    overflow-y: auto;\n    background: #f3f4f6;\n    padding: 1rem 0.5rem;\n  }\n  \n  /* Dark mode takeover styles */\n  .dark-mode .best-bets-takeover {\n    background: #1f2937;\n  }\n  \n  .dark-mode .best-bets-takeover-header {\n    background: linear-gradient(135deg, #111827 0%, #000000 100%);\n    border-bottom: 1px solid #374151;\n  }\n  \n  .dark-mode .best-bets-takeover-body {\n    background: #111827;\n  }\n\n  /* Mobile Filter Panel */\n  .best-bets-filter-panel {\n    max-height: 0;\n    overflow: hidden;\n    background: #f8f9fa;\n    border-bottom: 1px solid #dee2e6;\n    transition: max-height 0.3s ease-out;\n  }\n\n  .best-bets-filter-panel.open {\n    max-height: 300px;\n    transition: max-height 0.3s ease-in;\n  }\n\n  .filter-panel-content {\n    padding: 12px;\n  }\n\n  .mobile-filter-row {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 10px;\n    flex-wrap: wrap;\n  }\n\n  .mobile-filter-row:last-child {\n    margin-bottom: 0;\n  }\n\n  .mobile-filter-group {\n    flex: 1;\n    min-width: 80px;\n  }\n\n  .mobile-filter-group label {\n    display: block;\n    font-size: 0.7rem;\n    font-weight: 600;\n    color: #6b7280;\n    margin-bottom: 4px;\n    text-transform: uppercase;\n  }\n\n  .mobile-filter-group select {\n    width: 100%;\n    padding: 6px 8px;\n    font-size: 0.8rem;\n    border: 1px solid #d1d5db;\n    border-radius: 4px;\n    background: white;\n    color: #374151;\n  }\n\n  .mobile-filter-group.slider-group {\n    flex: 1;\n    min-width: 120px;\n  }\n\n  .slider-with-value {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .slider-with-value input[type=\"range\"] {\n    flex: 1;\n    height: 4px;\n    cursor: pointer;\n    appearance: none;\n    -webkit-appearance: none;\n    background: #d1d5db;\n    border-radius: 2px;\n    outline: none;\n  }\n\n  .slider-with-value input[type=\"range\"]::-webkit-slider-thumb {\n    appearance: none;\n    -webkit-appearance: none;\n    width: 16px;\n    height: 16px;\n    background: #0d6efd;\n    border-radius: 50%;\n    cursor: pointer;\n    border: 2px solid white;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  }\n\n  .slider-with-value input[type=\"range\"]::-moz-range-thumb {\n    width: 16px;\n    height: 16px;\n    background: #0d6efd;\n    border-radius: 50%;\n    cursor: pointer;\n    border: 2px solid white;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  }\n\n  .slider-with-value span {\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: #374151;\n    min-width: 40px;\n    text-align: right;\n  }\n\n  .slider-with-value .odds-input {\n    width: 60px;\n    padding: 4px 6px;\n    font-size: 0.75rem;\n    font-weight: 500;\n    border: 1px solid #d1d5db;\n    border-radius: 4px;\n    text-align: center;\n    background: white;\n    color: #374151;\n  }\n\n  .slider-with-value .odds-input:focus {\n    outline: none;\n    border-color: #0d6efd;\n    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.15);\n  }\n\n  /* Hide spinner arrows on number input */\n  .slider-with-value .odds-input::-webkit-inner-spin-button,\n  .slider-with-value .odds-input::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  .slider-with-value .odds-input[type=\"number\"] {\n    -moz-appearance: textfield;\n  }\n\n  .filter-actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 8px;\n    border-top: 1px solid #e5e7eb;\n  }\n\n  .filter-status {\n    font-size: 0.75rem;\n    color: #6b7280;\n  }\n\n  /* Dark mode filter panel */\n  .dark-mode .best-bets-filter-panel {\n    background: #1f2937;\n    border-bottom-color: #374151;\n  }\n\n  .dark-mode .mobile-filter-group label {\n    color: #9ca3af;\n  }\n\n  .dark-mode .mobile-filter-group select {\n    background: #374151;\n    border-color: #4b5563;\n    color: #e5e7eb;\n  }\n\n  .dark-mode .slider-with-value input[type=\"range\"] {\n    background: #4b5563;\n  }\n\n  .dark-mode .slider-with-value input[type=\"range\"]::-webkit-slider-thumb {\n    background: #60a5fa;\n    border-color: #1f2937;\n  }\n\n  .dark-mode .slider-with-value input[type=\"range\"]::-moz-range-thumb {\n    background: #60a5fa;\n    border-color: #1f2937;\n  }\n\n  .dark-mode .slider-with-value span {\n    color: #e5e7eb;\n  }\n\n  .dark-mode .slider-with-value .odds-input {\n    background: #374151;\n    border-color: #4b5563;\n    color: #e5e7eb;\n  }\n\n  .dark-mode .slider-with-value .odds-input:focus {\n    border-color: #60a5fa;\n    box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.2);\n  }\n\n  .dark-mode .filter-actions {\n    border-top-color: #374151;\n  }\n\n  .dark-mode .filter-status {\n    color: #9ca3af;\n  }\n\n  /* Toggle buttons styling */\n  .best-bets-takeover-header .btn-group {\n    border-radius: 4px;\n    overflow: hidden;\n  }\n  \n  .best-bets-takeover-header .btn {\n    padding: 0.25rem 0.75rem;\n    font-size: 0.875rem;\n    border: none;\n  }\n  \n  /* Best Bets Cards View */\n  .best-bets-mobile-cards {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n  \n  .best-bet-card {\n    background: white;\n    border-radius: 8px;\n    padding: 1rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    border-left: 4px solid transparent;\n  }\n  \n  /* Alternating background for cards */\n  .best-bets-mobile-cards .best-bet-card:nth-child(even) {\n    background: #fafafa;\n  }\n  \n  .dark-mode .best-bet-card {\n    background: #1f2937;\n    color: #e5e7eb;\n  }\n  \n  .dark-mode .best-bets-mobile-cards .best-bet-card:nth-child(even) {\n    background: #374151;\n  }\n  \n  .best-bet-card.tier-edge-one {\n    border-left-color: green;\n  }\n\n  .best-bet-card.tier-edge-two {\n    border-left-color: #F59E0B;\n  }\n\n  .best-bet-card.tier-edge-three {\n    border-left-color: #3B82F6;\n  }\n  \n  .best-bet-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0.75rem;\n  }\n  \n  .best-bet-game {\n    font-size: 0.85rem;\n    color: #6c757d;\n    font-weight: 500;\n  }\n  \n  .best-bet-player {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 1rem;\n    font-weight: 600;\n    font-size: 1rem;\n  }\n  \n  .best-bet-player .best-bets-team-logo {\n    width: 20px;\n    height: 20px;\n  }\n  \n  .best-bet-odds-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 0.5rem;\n  }\n  \n  .odds-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.5rem;\n    background: #f8f9fa;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n  }\n  \n  .dark-mode .odds-item {\n    background: #374151;\n    color: #e5e7eb;\n  }\n  \n  \n  .odds-item.best-book {\n    background: green;\n    color: yellow;\n    font-weight: bold;\n  }\n  \n  .best-bet-card.tier-edge-two .odds-item.best-book {\n    background: #F59E0B;\n    color: #1E40AF;\n    font-weight: bold;\n  }\n  \n  \n  .odds-item img {\n    height: 20px;\n    width: auto;\n  }\n  \n  .odds-item span {\n    font-family: 'Inter', sans-serif;\n    font-feature-settings: 'tnum';\n    font-size: 0.9rem;\n  }\n  \n  /* Best Bets List View */\n  .best-bets-mobile-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .best-bet-list-item {\n    background: white;\n    border-radius: 6px;\n    padding: 0.75rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    border-left: 3px solid transparent;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.75rem;\n    transition: all 0.2s ease;\n  }\n  \n  /* Alternating colors based on index within parent */\n  .best-bets-mobile-list > div:nth-child(even) .best-bet-list-item {\n    background: #fafafa;\n  }\n  \n  .dark-mode .best-bet-list-item {\n    background: #1f2937;\n    color: #e5e7eb;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n  }\n  \n  .dark-mode .best-bets-mobile-list > div:nth-child(even) .best-bet-list-item {\n    background: #374151;\n  }\n  \n  /* Remove default alternating - we'll handle it differently */\n  \n  .best-bet-list-item:hover {\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n  }\n  \n  .best-bet-list-item.expanded {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    margin-bottom: 0;\n  }\n  \n  .best-bet-list-item.tier-edge-one {\n    border-left-color: green;\n  }\n\n  .best-bet-list-item.tier-edge-two {\n    border-left-color: #F59E0B;\n  }\n\n  .best-bet-list-item.tier-edge-three {\n    border-left-color: #3B82F6;\n  }\n  \n  /* Left side of list item */\n  .best-bet-list-left {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n  \n  .best-bet-list-game {\n    font-size: 0.75rem;\n    color: #6c757d;\n    text-align: left;\n  }\n  \n  .best-bet-list-player {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    font-weight: 600;\n    font-size: 0.9rem;\n    flex: 1;\n    min-width: 0;\n  }\n  \n  .best-bet-list-player span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  \n  /* Right side of list item - FIXED GRID LAYOUT */\n  .best-bet-list-right {\n    display: grid;\n    grid-template-columns: 1fr 1fr auto;\n    grid-template-rows: auto auto;\n    gap: 0.25rem 0.5rem;\n    flex-shrink: 0;\n    align-items: center;\n    min-width: 160px;\n  }\n  \n  /* Row 1 positioning */\n  .best-bet-list-odds {\n    grid-column: 1 / span 2;\n    grid-row: 1;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    height: 20px;\n  }\n  \n  .expand-indicator {\n    grid-column: 3;\n    grid-row: 1;\n    font-size: 0.7rem;\n    color: #adb5bd;\n    transition: transform 0.2s ease;\n    justify-self: center;\n  }\n  \n  /* Row 2 positioning */\n  .market-badge-small {\n    grid-column: 1;\n    grid-row: 2;\n    background: #e9ecef;\n    padding: 0.05rem 0.25rem;\n    border-radius: 2px;\n    font-size: 0.65rem;\n    font-weight: 500;\n    color: #495057;\n    justify-self: start;\n  }\n  \n  .dark-mode .market-badge-small {\n    background: #4b5563;\n    color: #e5e7eb;\n  }\n  \n  .best-bet-list-right .best-bets-badge {\n    grid-column: 2;\n    grid-row: 2;\n    justify-self: center;\n  }\n  \n  /* Odds display components */\n  .best-odds-group {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n  }\n  \n  .best-odds {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    height: 20px;\n  }\n  \n  .best-odds img {\n    height: 14px !important;\n    width: auto !important;\n    flex-shrink: 0;\n  }\n  \n  .next-best-section {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    height: 20px;\n    justify-content: flex-start;\n  }\n  \n  .next-best-section img {\n    height: 14px !important;\n    width: auto !important;\n    max-width: 14px !important;\n    flex-shrink: 0;\n  }\n  \n  .odds-value {\n    font-family: 'Inter', sans-serif;\n    font-feature-settings: 'tnum';\n    font-weight: 600;\n    font-size: 0.85rem;\n    line-height: 1.2;\n  }\n  \n  .vs-text {\n    font-size: 0.75rem;\n    color: #adb5bd;\n    font-style: italic;\n    line-height: 1.2;\n    align-self: center;\n  }\n  \n  .best-odds .odds-value {\n    color: #000;\n    font-weight: bold;\n  }\n  \n  .best-bet-card.tier-edge-two .best-odds .odds-value {\n    color: #1E40AF;\n    font-weight: bold;\n  }\n  \n  .best-bet-card.tier-edge-three .best-odds .odds-value {\n    color: white;\n    font-weight: bold;\n  }\n  \n  /* Dark mode colors for mobile list view */\n  .dark-mode .best-odds .odds-value {\n    color: #ffffff;\n    font-weight: bold;\n  }\n  \n  .dark-mode .next-best-section .odds-value {\n    color: #9ca3af;\n    font-weight: 500;\n  }\n  \n  .next-best-section .odds-value {\n    color: #6c757d;\n    font-weight: 500;\n  }\n  \n  /* Expanded view */\n  .best-bet-expanded {\n    background: #f8f9fa;\n    border-left: 3px solid transparent;\n    border-bottom-left-radius: 6px;\n    border-bottom-right-radius: 6px;\n    padding: 0.75rem;\n    margin-bottom: 0.5rem;\n    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);\n  }\n  \n  .dark-mode .best-bet-expanded {\n    background: #111827;\n    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);\n  }\n  \n  .best-bet-list-item.tier-edge-one + .best-bet-expanded {\n    border-left-color: green;\n  }\n\n  .best-bet-list-item.tier-edge-two + .best-bet-expanded {\n    border-left-color: #F59E0B;\n  }\n\n  .best-bet-list-item.tier-edge-three + .best-bet-expanded {\n    border-left-color: #3B82F6;\n  }\n  \n  .all-odds-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 0.5rem;\n  }\n  \n  .expanded-odds-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.5rem;\n    background: white;\n    border-radius: 4px;\n    border: 1px solid #e9ecef;\n  }\n  \n  .dark-mode .expanded-odds-item {\n    background: #374151;\n    border: 1px solid #4b5563;\n    color: #e5e7eb;\n  }\n  \n  .dark-mode .expanded-odds-item.best-book.edge-three {\n    border: 2px solid #3b82f6;\n    background: rgba(59, 130, 246, 0.2);\n  }\n  \n  .expanded-odds-item.best-book {\n    border: 2px solid green;\n    background: rgba(0, 128, 0, 0.05);\n  }\n  \n  .expanded-odds-item.best-book.edge-two {\n    border: 2px solid #F59E0B;\n    background: rgba(245, 158, 11, 0.05);\n  }\n  \n  .expanded-odds-item img {\n    height: 20px;\n    width: auto;\n  }\n  \n  .expanded-odds-item span {\n    font-family: 'Inter', sans-serif;\n    font-feature-settings: 'tnum';\n    font-weight: 500;\n    font-size: 0.9rem;\n    color: #6c757d;\n  }\n  \n  /* Dark mode: make non-best books lighter */\n  .dark-mode .expanded-odds-item span {\n    color: #9ca3af;\n    font-weight: 500;\n  }\n  \n  /* Best book spans should be white and bold in dark mode */\n  .dark-mode .expanded-odds-item.best-book span {\n    color: #ffffff;\n    font-weight: 700;\n  }\n  \n  .dark-mode .expanded-odds-item.best-book.edge-two span {\n    color: #ffffff;\n    font-weight: 700;\n  }\n  \n  .dark-mode .expanded-odds-item.best-book.edge-three span {\n    color: #ffffff;\n    font-weight: 700;\n  }\n  \n  /* Light mode best book colors */\n  .expanded-odds-item.best-book span {\n    color: green;\n    font-weight: 700;\n  }\n\n  .expanded-odds-item.best-book.edge-two span {\n    color: #1E40AF;\n    font-weight: 700;\n  }\n\n  .expanded-odds-item.best-book.edge-three {\n    border: 2px solid #3B82F6;\n    background: rgba(59, 130, 246, 0.05);\n  }\n\n  .expanded-odds-item.best-book.edge-three span {\n    color: #3B82F6;\n    font-weight: 700;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
